/**
 * Auth session helpers.
 * Session is stored in localStorage so the user stays logged in
 * across page refreshes until they explicitly sign out.
 */

const SESSION_KEY = 'sterling_auth_session';

export function getAuthSession() {
  try { return JSON.parse(localStorage.getItem(SESSION_KEY)) || null; }
  catch { return null; }
}

export function setAuthSession(session) {
  localStorage.setItem(SESSION_KEY, JSON.stringify(session));
}

export function clearAuthSession() {
  localStorage.removeItem(SESSION_KEY);
}
